import { render, staticRenderFns } from "./FormControlModulestructureStartYear.vue?vue&type=template&id=c0f792a8"
import script from "./FormControlModulestructureStartYear.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureStartYear.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports